module.exports = __webpack_public_path__ + "static/media/pin_blue.54a0f9f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pin_blue.svg
// module id = 252
// module chunks = 0